const Colors = {
  White: "#fff",
  Black: "#000",
  Blue: "#2a3daa",
  DarkBlue: "#142256",
  DarkerBlue: "#1e1a33",
  Indigo: "#6574cd",
  Purple: "#9561e2",
  Pink: "#e7c9dd",
  Red: "#e53e3e",
  Orange: "#fdbf82",
  Green: "#38c172",
  Cyan: "#bcf3dd",
  LightCyan: "#bcf3ddcc",
  Gray: "#666666",
  GrayLight: "#707070",
  LightGray: "#00000029",
  LighterGray: "#f5f5f7",

  Info: "#bcf3dd", // cyan
  Success: "#38c172", // green
  Warning: "#fdbf82", // orange
  Danger: "#e53e3e", // red
  Primary: "#142256", // darkblue
  Secondary: "#bcf3dd", // cyan
  Tertiary: "#fdbf82", // orange
  Light: "#00000029", // lighter gray
  Dark: "#1e1a33", // darker blue
};

export { Colors };
